import { ActionTree } from 'vuex';
import { WalletInfoInterface } from './wallet.type';

export const actions: ActionTree<WalletInfoInterface, unknown> = {
  setWalletInfo({ commit }, walletInfo) {
    commit('SET_WALLET_INFO', walletInfo);
  },
};
